import api from './api';

function unwrap(response) {
  return response?.data?.dataset?.data || {};
}

function listParam(values) {
  return Array.isArray(values) && values.length ? values.join(',') : undefined;
}

export async function fetchDoubts({ filterType = 'all', page = 1, subjectIds = [], topicIds = [], tagCategoryIds = [] } = {}) {
  const response = await api.get('/doubts/get-doubts', {
    params: {
      filter_type: filterType,
      page: Number(page) || 1,
      ...(Array.isArray(subjectIds) && subjectIds.length ? { subject_ids: subjectIds } : {}),
      ...(Array.isArray(topicIds) && topicIds.length ? { topic_ids: topicIds } : {}),
      ...(Array.isArray(tagCategoryIds) && tagCategoryIds.length ? { tag_category_ids: tagCategoryIds } : {}),
    },
  });

  return unwrap(response);
}

export async function fetchDoubtTagsAndSubjects(categoryId, isAllDoubts = 1) {
  const response = await api.get('/doubts/get-tags-subjects', {
    params: { category_id: Number(categoryId), is_all_doubts: Number(isAllDoubts) },
  });

  return unwrap(response);
}

export async function fetchDoubtReportReasons() {
  const response = await api.get('/doubts/report-reasons');
  return unwrap(response);
}

export async function fetchDoubtDetail(doubtId) {
  const response = await api.get('/doubts/detail', { params: { doubt_id: Number(doubtId) } });
  return unwrap(response);
}

export async function toggleDoubtUpvote(doubtId) {
  const response = await api.post('/doubts/upvote-doubt', null, { params: { doubt_id: Number(doubtId) } });
  return unwrap(response);
}

export async function toggleReplyUpvote(replyId) {
  const response = await api.post('/doubts/upvote-reply', null, { params: { reply_id: Number(replyId) } });
  return unwrap(response);
}

export async function toggleDoubtBookmark(doubtId) {
  const response = await api.post('/doubts/bookmark-doubt', null, { params: { doubt_id: Number(doubtId) } });
  return unwrap(response);
}

export async function toggleMyDoubt(doubtId) {
  const response = await api.post('/doubts/toggle-my-doubt', null, { params: { doubt_id: Number(doubtId) } });
  return unwrap(response);
}

export async function markBestDoubtSolution({ doubtId, replyId }) {
  const response = await api.post('/doubts/mark-best-solution', { doubt_id: Number(doubtId), reply_id: Number(replyId) });
  return unwrap(response);
}

export async function reportDoubt({ doubtId, reportReasonId, description }) {
  const response = await api.post('/doubts/report-doubt', { doubt_id: Number(doubtId), report_reason_id: Number(reportReasonId), description: description || '' });
  return unwrap(response);
}

export async function blockDoubt(doubtId) {
  const response = await api.post('/doubts/block-doubt', null, { params: { doubt_id: Number(doubtId) } });
  return unwrap(response);
}

function formDataFor({ content, attachments = [], values = {} }) {
  const formData = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    if (Array.isArray(value)) value.forEach((entry) => formData.append(`${key}[]`, String(entry)));
    else if (value != null) formData.append(key, String(value));
  });
  formData.append('content', content || '');
  Array.from(attachments || []).forEach((file) => formData.append('attachments[]', file));
  return formData;
}

export async function addDoubtAnswer({ doubtId, content, attachments }) {
  const response = await api.post('/doubts/answer', formDataFor({ content, attachments, values: { doubt_id: doubtId } }), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return unwrap(response);
}

export async function editDoubtAnswer({ answerId, content, attachments, deleteAttachmentIds = [] }) {
  const response = await api.post('/doubts/edit-answer', formDataFor({ content, attachments, values: { answer_id: answerId, delete_attachment_ids: deleteAttachmentIds } }), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return unwrap(response);
}

export async function replyToDoubtAnswer({ doubtId, parentReplyId, content, attachments }) {
  const response = await api.post('/doubts/reply-to-answer', formDataFor({ content, attachments, values: { doubt_id: doubtId, parent_reply_id: parentReplyId } }), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return unwrap(response);
}

function doubtFormData({ doubtId, title, description, subjectIds = [], topicIds = [], tagCategoryIds = [], attachments = [], deleteAttachmentIds = [] }) {
  const formData = new FormData();
  formData.append('description', description || '');
  formData.append('title', title || '');
  subjectIds.forEach((id) => formData.append('subject_ids[]', String(id)));
  topicIds.forEach((id) => formData.append('topic_ids[]', String(id)));
  tagCategoryIds.forEach((id) => formData.append('tag_category_ids[]', String(id)));
  deleteAttachmentIds.forEach((id) => formData.append('delete_attachment_ids[]', String(id)));
  if (doubtId) formData.append('doubt_id', String(doubtId));
  Array.from(attachments || []).forEach((file) => formData.append('attachments[]', file));
  return formData;
}

export async function createDoubt(payload) {
  const response = await api.post('/doubts/create-doubt', doubtFormData(payload), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return unwrap(response);
}

export async function editDoubt(payload) {
  const response = await api.post('/doubts/edit-doubt', doubtFormData(payload), {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return unwrap(response);
}
